// assets/vm-view
import { selectAssetFileById } from './data-view';

class AssetsApi {

  getAssetFileById(assetId, onSuccess) {
    selectAssetFileById(assetId).then((result) => {
      return onSuccess(result);
    });
  }

}

export const assetsApi = new AssetsApi();
